// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"933":"b64e3b9d4b855176","975":"a22469a188ea844e"}[chunkId] + ".js";
};